import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";


export class DebitCardSelectorViewModel extends SelectorBaseViewModel<debitCard>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-A46B1056-C4F1-4D37-B927-1EA0B53A0C60";
    }

    protected async loadData(): Promise<debitCard[]> {
        let result =await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAccessibleDebitGateways',{})
        return result.Cards.map(x=>{
            let r = new debitCard(this);
            r.id = x.Id;
            r.title = `${x.AccountName} - ${x.CardNumber}`;
            return r;
        });
    }

}

export class debitCard extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}